import { defineDirective } from '~/scripts/utils/alpine'

/**
 * x-header-color directive
 * @example Set the header color to 'blue' when the section collides with the header
 * <div x-header-color="blue"></div>
 */
export default defineDirective(async (element, { expression }, { cleanup }) => {
  if (!expression || typeof expression !== 'string')
    return

  let previousColor: string | null
  const color = expression === 'blue' ? 'var(--color-blue-800)' : expression

  const [{ gsap }, { ScrollTrigger }] = await Promise.all([import('gsap'), import('gsap/ScrollTrigger')])
  gsap.registerPlugin(ScrollTrigger)

  const st = ScrollTrigger.create({
    trigger: element,
    start: () => `top ${(window.$store?.ui.headerHeight ?? 100) / 2}px`,
    end: () => `bottom ${(window.$store?.ui.headerHeight ?? 100) / 2}px`,
    onToggle: ({ isActive }) => {
      if (!window.$store?.ui)
        return

      if (isActive) {
        previousColor = window.$store.ui.headerColor
        window.$store.ui.headerColor = color
      }
      else {
        window.$store.ui.headerColor = previousColor
      }
    },
  })

  cleanup(() => {
    st.kill()
  })
})
